// @vue/component
export default {
  name: 'AddNewAgentGroup',

  props: {
    projectUuid: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      newGroup: null,
    };
  },

  methods: {
    async handleAddNewGroup() {
      const params = {
        name: this.newGroup,
        project: this.projectUuid,
      };

      await this.$store.dispatch('client/project/agentsGroups/createGroup', params);
      this.$store.dispatch('client/project/agentsGroups/getList', this.projectUuid);
    },
  },
};
